import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import CustodialAccount from "../custodial_acc_info/CustodialAccount";

function CustodialAccLanding(){
    return(
        <div className="custodial_landing">
             <Header />
            <CustodialAccount />
            <Footer />
        </div>
    )
}

export default CustodialAccLanding